<avi-state-page>
    <avi-state-page_main-content>
        <avi-page-header headerText="{{ l10nKeys.headerLabel | vtranslate }}"></avi-page-header>
        <avi-card
            [noBodyPadding]="true"
            [useContentHeight]="true"
        >
            <avi-card_body>
                <div class="upload-hsm-packages-page__upload-hsm-package">
                    <avi-input-container
                        [noMarginTop]="true"
                        helperText="{{ l10nKeys.uploadHsmPackageHelperText | vtranslate }}"
                    >
                        <label aviLabelWithTooltip>
                            {{ l10nKeys.uploadHsmPackageLabel | vtranslate }}
                        </label>
                        <async-file-upload-with-upload-service
                            [filePath]="filePath"
                            [fileApi]="fileApi"
                            accept=".tar"
                            [enableCancel]="true"
                        ></async-file-upload-with-upload-service>
                    </avi-input-container>
                </div>
            </avi-card_body>
        </avi-card>
    </avi-state-page_main-content>
</avi-state-page>
